import { Box, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  marginTop: '-10px',
  paddingTop: '10px',
}));

export const CardWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '344px',
  height: '95px',
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.colors.secondaryBackground,
  padding: '10px',
  marginBottom: '16px',
  [theme.breakpoints.up('md')]: {
    width: '603px',
    height: '125px',
    padding: '8px 22px 15px',
  },
}));

export const InlineContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '10px',
}));

export const TradeName = styled('span')(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
  },
}));

export const TradeInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'uppercase',
  marginTop: '2px',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    marginTop: '8px',
  },
}));

export const Separator = styled('div')(({ theme }) => ({
  width: '1px',
  height: '16px',
  backgroundColor: theme.palette.colors.lower,
  margin: '0 9px',
}));

export const FlagContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const WrapperData = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
}));

export const DataLabel = styled('span')(({ theme }) => ({
  fontSize: '10px',
  fontWeight: '500',
  color: theme.palette.colors.lower,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}));

export const DataValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'letters',
})(({ theme, letters }) => ({
  fontSize: letters ? '10px' : '12px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textTransform: 'uppercase',
  [theme.breakpoints.up('md')]: {
    fontSize: letters ? '12px' : '14px',
  },
}));

export const ListsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'listsHeight',
})(({ listsHeight }) => ({
  overflowY: 'auto',
  height: listsHeight,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}));
